import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-white">
                韩国漫画网
              </span>
            </Link>
            <p className="text-sm text-white/60 leading-relaxed">
              韩国漫画网专注于提供最新热门的在线韩漫阅读资源。涵盖恋爱、剧情、悬疑、动作等多种题材，是您发现精彩韩漫的首选平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-white mb-4">
              漫画分类
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-white/60 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-white mb-4">
              更多分类
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-white/60 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-white mb-4">
              关于我们
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-white/60 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-white/60 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  联系方式
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-white/60 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  用户口碑
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} 韩国漫画网 版权所有 | 本站内容仅供学习交流使用
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-sm text-white"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-sm text-white"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="QQ">
              <i className="ri-qq-line text-sm text-white"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}